<template>
  <div style="height: 100%; overflow: auto;">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        dense
        :items="table.items"
        :headers="table.headers"
        disable-pagination
        fixed-header
        hide-default-footer
      >
        <template #item="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <tr
                :style="{backgroundColor: getRowColor(item.day)}"
                v-on="on" v-bind="attrs"
              >
                <td class="day_cell"> {{ item.day }} </td>
                <td> {{ item.agent_count }} </td>
                <td> {{ item.min_inbound }} </td>
                <td> {{ item.min_callback }} </td>
                <td> {{ item.min_outbound }} </td>
                <td> {{ item.min_summ }} </td>
              </tr>
            </template>
            <span>{{ item.day }}</span><br>
            <span v-html="getDayTitle(item.day)"></span>
          </v-tooltip>
        </template>
      </v-data-table>

    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ForecastCalls',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      items: [],
      table: {
        items: [],
        headers: [
          {text: 'Дата', value: 'day'},
          {text: 'Кол-во операторов', value: 'agent_count'},
          {text: 'Вход очереди', value: 'min_inbound'},
          {text: 'Колбэк очереди', value: 'min_callback'},
          {text: 'Исход кампании', value: 'min_outbound'},
          {text: 'Сумма минут', value: 'min_summ'},
          // {text: 'Среднее (минут на оператора)', value: 'avg'},
        ],
      },
    }
  },

  computed: {
    ...mapGetters({
    }),
  },

  watch: {},

  methods: {
    ...mapActions({
      loadForecastCallsWidget: 'dashboard/loadForecastCallsWidget',
    }),

    getRowColor(day) {
      let dow = moment(day).day();

      if (moment(day).isSame(moment(), 'day')) return '#2196f320'
      if (dow === 0 || dow === 6) return '#9C27B020'
      if (moment(day).isAfter(moment())) return '#90A4AE20'
      return ''
    },

    getDayTitle(day) {
      let dow = moment(day).day();
      let dowName = '';
      switch (dow) {
        case 0:
          dowName = 'Воскресенье'
          break;
        case 1:
          dowName = 'Понедельник'
          break;
        case 2:
          dowName = 'Вторник'
          break;
        case 3:
          dowName = 'Среда'
          break;
        case 4:
          dowName = 'Четверг'
          break;
        case 5:
          dowName = 'Пятница'
          break;
        case 6:
          dowName = 'Суббота'
          break;
        case 7:
          dowName = 'Воскресенье'
          break;
      
        default:
          break;
      }

      if (moment(day).isSame(moment(), 'day')) dowName += '<br>Сегодня';
      if (moment(day).isAfter(moment())) dowName += '<br>Прогноз';
      return dowName
    },

    formTableData() {
      if (this.widget.params.only_forecast) {
        // с сегодня и до конца месяца оставляем
        let index = this.items.findIndex(item => moment(item.day).isSame(moment(), 'day'));
        this.items = this.items.splice(index);
      }

      this.table.items = this.items.map(el => {
        let min_summ = el.min_inbound + el.min_callback + el.min_outbound;
        return {...el, min_summ}
      })


      this.isLoaded = true;
    },

    async loadData() {
      this.isLoaded = false;
      this.items = await this.loadForecastCallsWidget(this.widget.params);
      this.formTableData()
    },

    test(day) {
      let tableDay = moment(day)
      // let today = moment().format('Y-M-D')
      // console.log(tableDay.format('Y-M-D'));
      // console.log(today);
      console.log(tableDay.isAfter(moment()));
    }
  },
  
  mounted() {
    this.loadData();
  },
}
</script>


<style scoped lang="scss">
.name-cell {
  display: grid;
  align-items: center;
  padding-left:0.2rem;
  padding-right:0.2rem;

  &.name {
    min-width: 50px;
    width: 100%;
  }
  
  &.weekend {
    background-color: #F4433620 !important;
  }
  
  .sliced-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

tr:hover {
  background-color: #9999993d !important;
}

.day_cell {
  white-space: nowrap;
}


</style>
<style>

</style>